import * as React from 'react';
export const CDSvg = React.forwardRef(function CDSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#FCD669',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        d: 'M10 0h4v1h-4V0ZM3 11h4v1H3v-1ZM0 5h1v4H0V5Zm15-2h1v3h-1V3Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 3 3 12H2a2 2 0 0 1-2-2V9l13.5-9h.5a2 2 0 0 1 2 2v1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M2.003 0H11.5L0 7.5V2.01A2 2 0 0 1 2.003 0ZM16 9.99c0 1.11-.9 2.01-1.992 2.01H5l11-7.5v5.49Z',
      }),
      /*#__PURE__*/ React.createElement('rect', {
        width: 2,
        height: 2,
        x: 2,
        y: 1,
        fill: '#FCD669',
        rx: 1,
      }),
    ),
  );
});
CDSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CD = {
  category: 'flag',
  colorable: false,
  name: 'CD',
  svg: CDSvg,
};
